import {Injectable} from '@angular/core';
import {BaseModelService} from '../../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class ChecklistsReportModelService extends BaseModelService {
  tableName = 'yu_v3_checklists_report';
}
